import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import React, { useImperativeHandle, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { DragPreviewImage, useDrag, useDragLayer, useDrop } from "react-dnd";
import Loader from "react-loader";
import { Formik, Form, ErrorMessage } from "formik";
import * as yup from "yup";
import ResizeTextarea from "react-textarea-autosize";
import {
  Button,
  Icon,
  IconButton,
  Spinner,
  Tooltip,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalOverlay,
  Text,
  Divider,
  Box,
  HStack,
  ModalCloseButton,
  ButtonGroup,
  Badge,
  InputGroup,
  Input,
  Flex,
  Textarea,
  AspectRatio,
} from "@chakra-ui/react";
import {
  FaEllipsisV,
  FaArrowRight,
  FaArrowsAlt,
  FaCheck,
  FaExpandArrowsAlt,
  FaGoogleDrive,
  FaShopify,
  FaSync,
  FaTimes,
  FaUserCircle,
  FaArrowLeft,
  FaPlay,
  FaPlusCircle,
} from "react-icons/fa";
import ReactPlayer from "react-player";
import { ReactComponent as BrandIcon } from "../../assets/logo/smp-s.svg";
import { ReactComponent as BrandTextIcon } from "../../assets/logo/white-smp-logo-with-text.svg";
import ArtBoardPreviewStaticCanvas from "../../TldrStoryDetail/ArtBoardPreviewStaticCanvas";
import { ImageSources, ItemTypes } from "../../_actions/types";
import {
  formatDuration,
  formatSelectedDuration,
  getImageProviderErrorsData,
  getSourceCreditInfoData,
} from "../../_utils/common";
import { MY_APPS } from "../../_utils/routes";
import {
  StyledArtBoardPreviewContainer,
  StyledArtboardPreviewDuration,
  StyledArtBoardPreviewStaticCanvasWrapper,
  StyledArtBoardPreviewTitle,
  StyledArtBoardRearrangeContainer,
  StyledTooltipWithKBDShortcut,
} from "../styled/details/styleArtBoardEditor";
import {
  StyledAnimationPlaybackActionButton,
  StyledCroppingElement,
  StyledElementHandle,
  StyledGalleryTypeHeader,
  StyledGalleryTypeHeaderTitle,
  StyledSetAsBackgroundHandle,
  StyledTextEditorCustomActionButton,
  StyledActionOnSection,
} from "../styled/details/stylesDetails";
import {
  StyledContentOverlay,
  StyledVideoDurationContainer,
  StyledCreatorInfo,
  StyledSaveAsTemplateTextBlock,
} from "../styled/styles";
import { light, primary } from "../styled/variable";
import storyCardPlaceHolder from "./../../assets/images/storyCard/storyCardPlaceHolder.png";
import ImageItemActions from "./ImageItemActions";
import SourceCreditInfo from "./SourceCreditInfo";
import TemplateItemActions from "./TemplateItemActions";
import TLDRImage from "./TLDRImage";
import TldrSidebarCloseAnchor from "./TldrSidebarCloseAnchor";
import TLDRSwiperImage from "./TLDRSwiperImage";
import {
  StyledDashboardGetStartedBox,
  StyledGetStartedDetailWrapper,
  StyledMarkerplaceHelpText,
  StyledSectionTitle,
} from "../styled/home/stylesHome";
import { renderChannelIcon } from "../../TldrCalendarPlanner/utils";

import { StoryTypes, BODY_SCROLL_LOCK_IGNORE } from "../../_utils/constants";
import { showToast } from "../../_utils/showToast";
import { isMobileView, openUrl } from "@simplified-workspace/shared/util";

dayjs.extend(duration);

export const initialNavBarFilterState = {
  title: "All",
  id: -1,
  description: "",
};

export const BrandLogo = ({ width, height }) => {
  const logoWidth = width != null ? width : 35;
  const logoHeight = width != null ? height : 35;
  return (
    <>
      {/* Brand Logo */}

      <BrandIcon
        style={{
          cursor: "pointer",
          display: "inline-block",
          alignItems: "top",
        }}
        width={logoWidth}
        height={logoHeight}
      />
    </>
  );
};

export const BrandTextLogo = ({ width, height }) => {
  const logoWidth = width != null ? width : 35;
  const logoHeight = width != null ? height : 35;
  return (
    <>
      {/* Brand Logo */}

      <BrandTextIcon
        style={{
          cursor: "pointer",
          display: "inline-block",
          alignItems: "top",
        }}
        width={logoWidth}
        height={logoHeight}
      />
    </>
  );
};

export const TextItem = (props) => {
  const [, drag] = useDrag({
    item: {
      type: ItemTypes.CARD,
      payload: props.data,
    },
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    }),
  });

  return (
    <div className={props.className} onClick={() => props.onClick()} ref={drag}>
      {props.children}
    </div>
  );
};

export const ImageItem = (props) => {
  const [{ isDragging }, drag, preview] = useDrag({
    item: {
      type: ItemTypes.CARD,
      payload: props.data,
    },
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    }),
    canDrag: props.canDrag === undefined ? true : props.canDrag,
  });
  const [isHovering, setIsHovering] = useState(false);
  const [played, setPlayed] = useState(0);
  const [loading, setLoading] = useState(false);

  const {
    source,
    hasAction,
    itemWidth,
    showOverlayInfo,
    type,
    modalFor,
    index,
    isUsedInSwiper,
    nativeImageStyles,
  } = props;
  let creditInfo = null;
  const { meta } = props?.data?.content || { meta: {} };

  if (source !== null) {
    let sourceCreditInfoData = getSourceCreditInfoData(source, props, meta);
    if (meta && sourceCreditInfoData?.authorName) {
      creditInfo = (
        <SourceCreditInfo
          authorName={sourceCreditInfoData.authorName}
          authorLink={sourceCreditInfoData.authorLink}
          sourceSiteName={sourceCreditInfoData.sourceSiteName}
          sourceSiteLink={sourceCreditInfoData.sourceSiteLink}
          isDragging={isDragging}
        />
      );
    }
  }

  function onMouseLeave() {
    setIsHovering(false);
    setLoading(false);
    setPlayed(0);
  }

  function onMouseEnter() {
    setIsHovering(true);
    setLoading(true);
  }

  return (
    <>
      {props.url && <DragPreviewImage connect={preview} src={props.url} />}

      <div
        className="thumbnail"
        ref={drag}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        {showOverlayInfo !== false ? (
          <StyledContentOverlay
            className="content-overlay"
            isDragging={isDragging}
          />
        ) : (
          <></>
        )}

        {isUsedInSwiper ? (
          <TLDRSwiperImage
            src={props.url}
            width={itemWidth || 152.5}
            height={
              ((itemWidth || 152.5) * parseInt(props.height)) /
              parseInt(props.width)
            }
          />
        ) : (
          <>
            <TLDRImage
              NativeImgProps={{ style: { opacity: isDragging ? 0.5 : 1 } }}
              src={props.url}
              alt={props.alt}
              width={itemWidth || 152.5}
              height={
                ((itemWidth || 152.5) * parseInt(props.height)) /
                parseInt(props.width)
              }
              style={nativeImageStyles}
              data-width={itemWidth || 152.5}
              data-height={
                ((itemWidth || 152.5) * parseInt(props.height)) /
                parseInt(props.width)
              }
            />

            {props.data.mime === "video" && isHovering && (
              <Box className="preview-video">
                {loading && (
                  <Spinner
                    position="absolute"
                    top="40%"
                    bottom="60%"
                    left="40%"
                    right="60%"
                    className="spin"
                  />
                )}

                <ReactPlayer
                  url={props.video_src}
                  muted
                  playing
                  onProgress={(progress) => {
                    setPlayed(Math.ceil(progress.playedSeconds));
                  }}
                  className="video-preview"
                  width="100%"
                  height="100%"
                  controls={false}
                  onPlay={() => setLoading(false)}
                />

                <StyledVideoDurationContainer>
                  <span>
                    {isHovering &&
                      `${dayjs.duration(played, "seconds").format("mm:ss")} / `}
                  </span>
                  <Duration
                    type="video_duration"
                    seconds={
                      meta.duration ? meta.duration : meta.payload?.duration
                    }
                  />
                </StyledVideoDurationContainer>
              </Box>
            )}
          </>
        )}

        {props.data.mime === "video" && !isHovering && (
          <StyledVideoDurationContainer>
            <Duration
              type="video_duration"
              seconds={meta.duration ? meta.duration : meta.payload?.duration}
            />
          </StyledVideoDurationContainer>
        )}

        {showOverlayInfo !== false ? creditInfo : <></>}

        {((isHovering && !isMobileView()) || isMobileView()) && hasAction && (
          <>
            {modalFor === "template" ? (
              <TemplateItemActions
                id={meta.id}
                title={meta.title}
                index={index}
                type={type}
                modalFor={modalFor}
                showExtraOptions={false}
              />
            ) : (
              <ImageItemActions
                id={meta.id}
                type={type}
                modalFor={modalFor}
                showExtraOptions={false}
              />
            )}
          </>
        )}
      </div>
    </>
  );
};

export const ImageItemWithoutDrag = (props) => {
  const { source, hasAction, itemWidth, showOverlayInfo, type, modalFor } =
    props;
  let creditInfo = null;
  const { meta } = props.data.content || { meta: {} };

  if (source !== null) {
    let sourceCreditInfoData = getSourceCreditInfoData(source, props, meta);
    if (meta) {
      creditInfo = (
        <SourceCreditInfo
          authorName={sourceCreditInfoData.authorName}
          authorLink={sourceCreditInfoData.authorLink}
          sourceSiteName={sourceCreditInfoData.sourceSiteName}
          sourceSiteLink={sourceCreditInfoData.sourceSiteLink}
        />
      );
    }
  }

  const width = parseInt(props.width);
  const height = parseInt(props.height);

  return (
    <>
      <div className="thumbnail">
        <AspectRatio ratio={width / height}>
          <TLDRImage
            NativeImgProps={{ style: { opacity: 1 } }}
            src={props.url}
            alt={props.alt}
            width={itemWidth || 152.5}
            height={((itemWidth || 152.5) * height) / width}
            data-width={itemWidth || 152.5}
            data-height={((itemWidth || 152.5) * height) / width}

          />
        </AspectRatio>
        {props.data.mime === "video" && (
          <StyledVideoDurationContainer>
            <Duration
              type="video_duration"
              seconds={
                meta?.duration ? meta.duration : meta?.payload?.duration || 0
              }
            />
          </StyledVideoDurationContainer>
        )}
        {showOverlayInfo !== false ? creditInfo : <></>}
        {hasAction && (
          <ImageItemActions id={meta.id} type={type} modalFor={modalFor} />
        )}
      </div>
    </>
  );
};

export const ProductImageItem = (props) => {
  const { itemWidth } = props;

  return (
    <>
      <div className="thumbnail">
        <TLDRImage
          src={props.url}
          alt={props.alt}
          width={itemWidth || 152.5}
          height={
            ((itemWidth || 152.5) * parseInt(props.height)) /
            parseInt(props.width)
          }
          data-width={itemWidth || 152.5}
          data-height={
            ((itemWidth || 152.5) * parseInt(props.height)) /
            parseInt(props.width)
          }
        />
      </div>
    </>
  );
};

export const ShowCenterSpinner = ({ loaded, className }) => {
  let options = {
    lines: 8,
    length: 0,
    width: 10,
    radius: 18,
    scale: 1.0,
    corners: 1,
    color: "#ffac41",
    opacity: 0.25,
    rotate: 0,
    direction: 1,
    speed: 1,
    trail: 60,
    fps: 20,
    zIndex: 2e9,
    top: "50%",
    left: "50%",
    shadow: false,
    hwaccel: false,
    position: "absolute",
  };
  return (
    <Loader
      loaded={loaded}
      options={options}
      className={className + " spinner"}
    />
  );
};

export const SidebarPanel = ({ childComp, onClose }) => {
  return (
    <>
      <section
        bodyscrolllockignore={BODY_SCROLL_LOCK_IGNORE}           //ignores default scroll lock on mobile ios
        className={
          "tldr-main-sidebar-item-detail-slider tldr-main-sidebar-item-detail-slider-" +
          "open"
        }
      >
        <div className="panel-container">
          <TldrSidebarCloseAnchor onClose={onClose} />
          {childComp}
        </div>
      </section>
    </>
  );
};

export const MarketplaceTemplatesAction = ({
  action,
  id,
  tooltip,
  icon,
  clickHandler,
  label,
}) => {
  return (
    <Tooltip label={tooltip} placement="top" hasArrow>
      <>
        <Box
          className="action"
          onClick={(e) => {
            e.stopPropagation();
            clickHandler(action, id);
          }}
          cursor="pointer"
        >
          {icon}
        </Box>
        <span>{label}</span>
      </>
    </Tooltip>
  );
};

export const ShowNoContent = ({ text }) => {
  return <div className="no-content avoid-capturing">{text}</div>;
};

export const RequestTemplateContent = ({ text }) => {
  const { t } = useTranslation(["common"]);
  return (
    <div className="no-content avoid-capturing">
      {text}.
      <a
        target="_blank"
        rel="noreferrer"
        href="https://simplified.feedbear.com/boards/templates"
      >
        {t("intro_page.click_here")}
      </a>
      {t("intro_page.to_Req")}
    </div>
  );
};

export const ShowNoObject = ({ text }) => {
  return <div className="no-object avoid-capturing">{text}</div>;
};

export const ShowBrandKitInfo = ({ text }) => {
  return <div className="no-brandkit-content avoid-capturing">{text}</div>;
};

export const ImageSourceIcon = ({ imageSource }) => {
  switch (imageSource) {
    case ImageSources.GOOGLE_DRIVE:
      return <Icon as={FaGoogleDrive} fontSize="6rem" mt={3} />;
    case ImageSources.SHOPIFY:
      return <Icon as={FaShopify} fontSize="6rem" mt={3} />;
    default:
      return null;
  }
};

export const ImageProvierErrorsInfo = ({
  imageProviderErrors,
  imageSource,
}) => {
  const errorsData = getImageProviderErrorsData(
    imageSource,
    imageProviderErrors
  );
  const { actionText, errorsText } = errorsData;

  return (
    <>
      <div className="no-shopify-content">
        {errorsText &&
          errorsText.map((error, idx) => <span key={idx}>{error}</span>)}
        <ImageSourceIcon imageSource={imageSource} />
        <Button
          onClick={() => {
            openUrl(MY_APPS, "_blank");
          }}
          variant="solid"
          mt={3}
        >
          {actionText}
        </Button>
        {/* TODO: align div in such a way that button should automatically come next to icon,without position absolute */}
      </div>
    </>
  );
};

export const MoveElementsHandle = ({ className, style }) => {
  return (
    <StyledElementHandle className={className} style={style}>
      <FaArrowsAlt size="0.75em" color={primary} />
    </StyledElementHandle>
  );
};

export const ApplyCropOnImage = ({ className, style, onClick }) => {
  return (
    <StyledCroppingElement
      className={className}
      style={style}
      onClick={onClick}
    >
      <FaCheck size="0.75em" color={primary} />
    </StyledCroppingElement>
  );
};

export const CancelImageCrop = ({ className, style, onClick }) => {
  return (
    <StyledCroppingElement
      className={className}
      style={style}
      onClick={onClick}
    >
      <FaTimes size="0.75em" color={primary} />
    </StyledCroppingElement>
  );
};

export const RotateElementsHandle = ({ className, style }) => {
  return (
    <StyledElementHandle className={className} style={style}>
      <FaSync size="0.75em" color={primary} />
    </StyledElementHandle>
  );
};

export const SetAsBackgroundHandle = ({
  className,
  style,
  setAsBackground,
  scale,
}) => {
  const { t } = useTranslation(["studio"]);
  return (
    <Tooltip label={t("context_menu.set_as_bg")} placement="bottom" hasArrow>
      <StyledSetAsBackgroundHandle
        className={className}
        style={style}
        onClick={setAsBackground}
        scale={scale}
      >
        <FaExpandArrowsAlt size="0.75em" color={primary} />
      </StyledSetAsBackgroundHandle>
    </Tooltip>
  );
};

export const TldrConfirmationModal = (props) => {
  const {
    show,
    onHide,
    inProgress,
    modalFor,
    customMessage,
    customBodyMessage,
    customPrimaryActionText,
  } = props;
  const { t } = useTranslation(["studio", "common"]);
  return (
    <Modal isOpen={show} onClose={onHide} isCentered size="sm">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader p="4">
          {customMessage
            ? customMessage
            : t("confirmation_modal.modal_title", { modalFor: modalFor })}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody p="0">
          <Divider my="0" />
          <Text p="4">
            {customBodyMessage
              ? customBodyMessage
              : t("confirmation_modal.modal_body")}
          </Text>
          <Divider my="0" />
        </ModalBody>
        <ModalFooter p="3">
          <ButtonGroup>
            <Button
              onClick={(e) => {
                e.stopPropagation();
                props.onHide();
              }}
              colorScheme="primary"
              variant="secondary"
              disabled={inProgress}
            >
              {t("no", { ns: "common" })}
            </Button>
            <Button
              onClick={(e) => {
                e.stopPropagation();
                props.onYes();
              }}
              colorScheme="primary"
              variant="solid"
              isLoading={inProgress}
              loadingText={t("confirmation_modal.modal_Delete_loading")}
            >
              {customPrimaryActionText
                ? customPrimaryActionText
                : t("delete", { ns: "common" })}
            </Button>
          </ButtonGroup>
        </ModalFooter>
      </ModalContent>
    </Modal>
    // <></>
  );
};

export const TldrBasicConfirmationModal = (props) => {
  const { show, onHide, inProgress, title, message } = props;
  const { t } = useTranslation(["studio", "common"]);
  return (
    <Modal isOpen={show} onClose={onHide} isCentered size="sm">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader p="4">{title}</ModalHeader>
        <ModalCloseButton />
        <ModalBody p="0">
          <Divider my="0" />
          <Text p={4}>{message}</Text>
          <Divider my="0" />
        </ModalBody>
        <ModalFooter p={3}>
          <ButtonGroup>
            <Button
              onClick={(e) => {
                e.stopPropagation();
                props.onHide();
              }}
              disabled={inProgress}
              colorScheme="primary"
              variant="secondary"
            >
              {t("no", { ns: "common" })}
            </Button>
            <Button
              onClick={(e) => {
                e.stopPropagation();
                props.onYes();
              }}
              colorScheme="primary"
              variant="solid"
              disabled={inProgress}
              isLoading={inProgress}
              loadingText={t("basic_confirmation_modal.modal_loading_btn")}
            >
              {t("yes", { ns: "common" })}
            </Button>
          </ButtonGroup>
        </ModalFooter>
      </ModalContent>
      {/* <Modal.Header>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{message}</Modal.Body>
      <Modal.Footer>
        <Button
          onClick={(e) => {
            e.stopPropagation();
            props.onHide();
          }}
          disabled={inProgress}
          mr={2}
        >
          No
        </Button>
        <Button
          onClick={(e) => {
            e.stopPropagation();
            props.onYes();
          }}
          colorScheme="primary"
          disabled={inProgress}
          isLoading={inProgress}
          loadingText="Please wait.."
        >
          Yes
        </Button>
      </Modal.Footer> */}
    </Modal>
    // <></>
  );
};

export const TldrProgressDialog = (props) => {
  const { show, onHide, inProgress } = props;
  const { t } = useTranslation(["studio"]);
  return (
    <Modal isOpen={show} onClose={onHide} isCentered size="sm">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader p="4">{t("progress_modal.modal_title")}</ModalHeader>
        <ModalCloseButton />
        <ModalBody p="0">
          <Divider my="0" />
          <Text p={3}>{t("progress_modal.modal_body")}</Text>
        </ModalBody>
        <Divider my="0" />
        <ModalFooter p={3}>
          <Button
            colorScheme="primary"
            variant="solid"
            isLoading={inProgress}
            loadingText={t("progress_modal.modal_loading_btn")}
          ></Button>
        </ModalFooter>
      </ModalContent>
      {/* <Modal.Header>
        <Modal.Title>Cloning it now.</Modal.Title>
      </Modal.Header>
      <Modal.Body>Hang in there, cloning all the assets, styles.</Modal.Body>
      <Modal.Footer>
        <Button
          variant="solid"
          isLoading={inProgress}
          loadingText=" Cloning..."
        ></Button>
      </Modal.Footer> */}
    </Modal>
    // <></>
  );
};

export const TldrUnlockWarningDialog = (props) => {
  const { show, onHide, inProgress } = props;
  const { t } = useTranslation(["studio", "common"]);
  return (
    <Modal isOpen={show} onClose={onHide} isCentered size="sm">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader p={4}>{t("unlock_warning_modal.modal_title")}</ModalHeader>
        <ModalCloseButton />
        <ModalBody p={0}>
          <Divider my={0} />
          <Text p={4}>{t("unlock_warning_modal.modal_body")}</Text>
          <Divider my="0" />
        </ModalBody>
        <ModalFooter p="3">
          <ButtonGroup>
            <Button
              onClick={(e) => {
                e.stopPropagation();
                props.onHide();
              }}
              colorScheme="primary"
              variant="secondary"
              disabled={inProgress}
            >
              {t("no", { ns: "common" })}
            </Button>
            <Button
              onClick={(e) => {
                e.stopPropagation();
                props.onYes();
              }}
              colorScheme="primary"
              variant="solid"
            >
              {t("unlock_warning_modal.modal_unlock_now_btn")}
            </Button>
          </ButtonGroup>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export const TldrConfirmActionModal = (props) => {
  const { show, onHide, inProgress } = props;
  const { t } = useTranslation(["studio", "common"]);
  return (
    <Modal isOpen={show} onClose={onHide} isCentered size="sm">
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton />
        <ModalHeader p="4">{t("confirm_action_modal.modal_title")}</ModalHeader>
        <ModalBody p="0">
          <Divider my="0" />
          <Text p={3}>{t("confirm_action_modal.modal_body")}</Text>
          <Divider my="0" />
        </ModalBody>
        <ModalFooter p="3">
          <ButtonGroup>
            <Button
              onClick={(e) => {
                e.stopPropagation();
                props.onHide();
              }}
              colorScheme="primary"
              variant="secondary"
              disabled={inProgress}
            >
              {t("no", { ns: "common" })}
            </Button>
            <Button
              onClick={(e) => {
                e.stopPropagation();
                props.onYes();
              }}
              colorScheme="primary"
              variant="solid"
            >
              {t("delete", { ns: "common" })}
            </Button>
          </ButtonGroup>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export const TldrCustomSidebarIconAction = ({
  action,
  icon,
  title,
  callback,
  disabled,
  shortcutKeys,
}) => {
  return (
    <Tooltip
      label={
        <StyledTooltipWithKBDShortcut>
          {title}
          {shortcutKeys && (
            <div className="hotkeys">
              <kbd>{shortcutKeys[0]}</kbd>{" "}
              {shortcutKeys[1] && <kbd>{shortcutKeys[1]}</kbd>}{" "}
              {shortcutKeys[2] && <kbd>{shortcutKeys[2]}</kbd>}
            </div>
          )}
        </StyledTooltipWithKBDShortcut>
      }
      placement="bottom"
      hasArrow
    >
      <StyledTextEditorCustomActionButton
        disabled={disabled}
        onClick={() => callback(action)}
      >
        {icon}
      </StyledTextEditorCustomActionButton>
    </Tooltip>
  );
};

export const TldrCollapsableAction = ({
  action,
  icon,
  title,
  callback,
  disabled,
  hidden,
}) => {
  return (
    <Tooltip placement="bottom" hasArrow label={title}>
      <StyledActionOnSection
        onClick={() => callback(action)}
        disabled={disabled}
        hidden={hidden}
      >
        {icon}
      </StyledActionOnSection>
    </Tooltip>
  );
};

export const TldrAction = ({
  action,
  icon,
  title,
  callback,
  className,
  disabled,
  hidden,
  userAction,
  shortcutKeys,
  inProgress,
  margin,
}) => {
  return (
    <Tooltip
      label={
        <StyledTooltipWithKBDShortcut>
          {title}
          {shortcutKeys && (
            <div className="hotkeys">
              <kbd>{shortcutKeys[0]}</kbd>{" "}
              {shortcutKeys[1] && <kbd>{shortcutKeys[1]}</kbd>}{" "}
              {shortcutKeys[2] && <kbd>{shortcutKeys[2]}</kbd>}
            </div>
          )}
        </StyledTooltipWithKBDShortcut>
      }
      hasArrow
      placement="bottom"
    >
      <StyledTextEditorCustomActionButton
        className={className ? className : ""}
        onClick={() => callback(action, userAction)}
        disabled={disabled}
        hidden={hidden}
        margin={margin}
      >
        {inProgress ? <Spinner size="sm" color="primary.400" mt={1} /> : icon}
      </StyledTextEditorCustomActionButton>
    </Tooltip>
  );
};

export const TldrCustomIconAction = ({
  action,
  icon,
  title,
  callback,
  className,
  disabled,
  hidden,
  userAction,
}) => {
  return (
    <Tooltip hasArrow placement="bottom" label={title}>
      <StyledTextEditorCustomActionButton
        className={className ? className : ""}
        onClick={( ) => callback(action, userAction)}
        disabled={disabled}
        hidden={hidden}
      >
        {icon}
      </StyledTextEditorCustomActionButton>
    </Tooltip>
  );
};

export const TldrEditorAction = ({
  action,
  icon,
  title,
  callback,
  active,
  disabled,
  shortcutKeys,
  showHover,
  margin,
}) => {
  return (
    <Tooltip
      hasArrow
      placement="bottom"
      shouldWrapChildren
      label={
        <StyledTooltipWithKBDShortcut>
          {title}
          {shortcutKeys && (
            <div className="hotkeys">
              <kbd>{shortcutKeys[0]}</kbd> <kbd>{shortcutKeys[1]}</kbd>{" "}
              {shortcutKeys[2] && <kbd>{shortcutKeys[2]}</kbd>}
            </div>
          )}
        </StyledTooltipWithKBDShortcut>
      }
    >
      <IconButton
        size={"sm"}
        variant="unstyled"
        onClick={() => callback(action)}
        disabled={disabled || false}
        _hover={showHover && { color: primary }}
        margin={margin}
        icon={
          <Icon
            className="fa-light"
            as={icon}
            maxH="16px"
            color={active && primary}
          />
        }
       aria-label="icon"
      />
    </Tooltip>
  );
};

export const TldrAnimationPlaybackAction = ({
  action,
  icon,
  title,
  callback,
  className,
  disabled,
  margin,
}) => {
  return (
    <Tooltip hasArrow placement="bottom" label={title}>
      <StyledAnimationPlaybackActionButton
        className={className ? className : ""}
        onClick={() => callback(action)}
        disabled={disabled}
        margin={margin}
      >
        {icon}
      </StyledAnimationPlaybackActionButton>
    </Tooltip>
  );
};

export const TldrNavbarButton = ({
  action,
  icon,
  title,
  callback,
  className,
}) => {
  return (
    <Tooltip hasArrow placement="bottom" label={title}>
      <StyledTextEditorCustomActionButton
        className={className ? className : ""}
        onClick={() => callback(action)}
      >
        {icon}
      </StyledTextEditorCustomActionButton>
    </Tooltip>
  );
};

export const Dropable = (props) => {
  const collectedProps = useDragLayer((monitor) => monitor);

  const [, drop] = useDrop({
    accept: ItemTypes.CARD,
    drop: (item) => {
      props.onDrop(item.payload);
      return { moved: true };
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  });

  useImperativeHandle(props.droppableRef, () => ({
    item: collectedProps?.store?.getState()?.dragOperation?.item,
  }));

  return (
    <div
      ref={drop}
      style={{
        width: `100%`,
        height: `100%`,
      }}
      className={props.className}
    >
      {props.children}
    </div>
  );
};

export function Handle({ handle: { id, value, percent }, getHandleProps }) {
  return (
    <div
      style={{
        left: `${percent}%`,
        position: "absolute",
        marginLeft: -15,
        marginTop: 25,
        zIndex: 2,
        width: 30,
        height: 30,
        border: 0,
        textAlign: "center",
        cursor: "pointer",
        borderRadius: "50%",
        backgroundColor: "#2C4870",
        color: "#333",
      }}
      {...getHandleProps(id)}
    >
      <div style={{ fontFamily: "Roboto", fontSize: 11, marginTop: -35 }}>
        {value}
      </div>
    </div>
  );
}

export const StoryCardPlaceHolder = ({ height, width }) => {
  return (
    <img
      src={storyCardPlaceHolder}
      alt="story card placeholder"
      height={height}
      width={width}
    ></img>
  );
};

export const GalleryTypeHeaderTitle = ({
  title,
  moreOpened,
  toggleMore,
  hasViewMore = true,
}) => {
  const { t } = useTranslation(["common"]);
  return (
    <StyledGalleryTypeHeader>
      {moreOpened && (
        <Icon
          as={FaArrowLeft}
          onClick={toggleMore}
          color="white"
          cursor="pointer"
          mr={1}
        />
      )}
      <StyledGalleryTypeHeaderTitle>{title}</StyledGalleryTypeHeaderTitle>
      {!moreOpened && hasViewMore ? (
        <div className="all" onClick={toggleMore}>
          <span>{t("view_all")}</span>
        </div>
      ) : null}
    </StyledGalleryTypeHeader>
  );
};

export const TldrCreateComponentModal = (props) => {
  const { show, onHide, inProgress } = props;
  const { t } = useTranslation(["studio", "common"]);

  return (
    <Modal isOpen={show} onClose={onHide} isCentered size="sm">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader p="4">
          {inProgress
            ? t("create_component_modal.modal_title_create")
            : t("create_component_modal.modal_title_save")}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody p="0">
          <Divider my="0" />
          <Text p={4}>
            {inProgress
              ? t("create_component_modal.modal_body_create_loading")
              : t("create_component_modal.modal_body_create")}
          </Text>
          <Divider my="0" />
        </ModalBody>
        <ModalFooter p={3}>
          <ButtonGroup>
            <Button
              onClick={(e) => {
                e.stopPropagation();
                props.onHide();
              }}
              colorScheme="primary"
              variant="secondary"
              disabled={inProgress}
            >
              {t("cancel", { ns: "common" })}
            </Button>
            <Button
              onClick={(e) => {
                e.stopPropagation();
                props.onYes();
              }}
              colorScheme="primary"
              variant="solid"
              isLoading={inProgress}
              loadingText={t("create_component_modal.modal_create_loading_btn")}
            >
              {t("create_component_modal.modal_create_now_btn")}
            </Button>
          </ButtonGroup>
        </ModalFooter>
      </ModalContent>

      {/* <Modal.Header>
        <Modal.Title>
          {inProgress ? "Creating a new component." : "Save as component"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {inProgress
          ? "Hang in tight, creating a new component."
          : "Create component once and use it anywhere."}
      </Modal.Body>
      <Modal.Footer>
        <Button
          onClick={(e) => {
            e.stopPropagation();
            props.onHide();
          }}
          colorScheme={"primary"}
          variant="outline"
          disabled={inProgress}
          mr={2}
        >
          Cancel
        </Button>
        <Button
          onClick={(e) => {
            e.stopPropagation();
            props.onYes();
          }}
          colorScheme="primary"
          isLoading={inProgress}
          loadingText="Creating..."
        >
          Create Now
        </Button>
      </Modal.Footer> */}
    </Modal>
    // <></>
  );
};

export const getCurrentMediaSource = (props, state) => {
  let mediaSource = "";
  switch (props.sidebarSlider.sliderPanelType) {
    case "video":
      mediaSource = props.sidebarSlider.videoSource;
      break;
    case "images":
      mediaSource = props.sidebarSlider.imageSource;
      break;
    case "icons":
      mediaSource = state.selectedSource || props.sidebarSlider.iconsSource;
      break;
    case "music":
      mediaSource = props.sidebarSlider.musicSource;
      break;
    default:
      break;
  }
  return mediaSource;
};

export const TldrLicenseAgreementText = (props) => {
  const { t } = useTranslation(["common"]);
  return (
    <div className="thirdparty-license-agreement license-agreement-text">
      <p>
        {props.text}
        <a
          href={props.redirectTo}
          className="license-agreement"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t("read_more")}
        </a>
      </p>
    </div>
  );
};

export const Duration = ({ type, seconds }) => {
  return (
    <time dateTime={`P${Math.round(seconds)}S`}>
      {type === "video_duration"
        ? formatDuration(seconds)
        : formatSelectedDuration(seconds)}
    </time>
  );
};

export const DraggablePreviewArtBoard = (props) => {
  const { id, page, isCurrentPage, canvasRef } = props;
  const pageDuration = page?.payload?.animation?.duration;
  const ref = useRef(null);
  const [, drop] = useDrop({
    accept: ItemTypes.ARTBOARD,
    hover: (item) => {
      if (!ref.current) {
        return;
      }
      const dragIndex = item.id;
      const hoverIndex = id;

      if (dragIndex === hoverIndex) {
        return;
      }
      // const hoverBoundingRect = ref.current?.getBoundingClientRect();
      // const hoverMiddleY =
      //   (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      // const clientOffset = monitor.getClientOffset();
      // const hoverClientY = clientOffset.y - hoverBoundingRect.top;
      // if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
      //   return;
      // }
      // if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
      //   return;
      // }

      props.onMoveItem(dragIndex, hoverIndex);
    },
    drop: (item) => {
      props.onDrop(item.id);
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  });
  const [, drag] = useDrag({
    item: {
      type: ItemTypes.ARTBOARD,
      id,
    },
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    }),
  });

  drag(ref);
  drop(ref);

  return (
    <StyledArtBoardRearrangeContainer
      ref={ref}
      className={isCurrentPage ? "active" : ""}
    >
      <StyledArtBoardPreviewContainer>
        <StyledArtBoardPreviewTitle location="preview-container">
          <p>{page.order + 1}</p>
        </StyledArtBoardPreviewTitle>
        {pageDuration && (
          <StyledArtboardPreviewDuration>
            {dayjs.duration(pageDuration, "seconds").format("mm:ss")}
          </StyledArtboardPreviewDuration>
        )}
        <StyledArtBoardPreviewStaticCanvasWrapper>
          <ArtBoardPreviewStaticCanvas page={page} canvasRef={canvasRef} />
        </StyledArtBoardPreviewStaticCanvasWrapper>
      </StyledArtBoardPreviewContainer>
    </StyledArtBoardRearrangeContainer>
  );
};

const validationSchemaProjectName = yup.object({
  projectName: yup.string().max(50).required("Project Name cannot be empty."),
});

export const EditProjectName = ({
  props,
  handleCloseAddModal,
  signal,
}) => {
  const { t } = useTranslation(["studio", "common"]);
  return (
    <Formik
      enableReinitialize
      validationSchema={validationSchemaProjectName}
      initialValues={{
        projectName: props.story.payload.title,
      }}
      onSubmit={(values, { setSubmitting }) => {
        props.updateStory(
          props.story.payload.id,
          { title: values.projectName },
          signal,
          {
            ...props,
          }
        );
        setSubmitting(false);
      }}
    >
      {({ isSubmitting, isValid, values, handleChange, handleBlur }) => (
        <Form>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader p="4">
              {t("edit_project_name_modal.modal_title")}
            </ModalHeader>
            <ModalCloseButton />
            <Divider my="0" />
            <ModalBody p="4">
              <InputGroup>
                <Input
                  type="text"
                  name="projectName"
                  placeholder={t("project_name")}
                  value={values.projectName}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
              </InputGroup>
              <ErrorMessage
                name="projectName"
                component="div"
                className="error"
              />
            </ModalBody>
            <Divider my="0" />
            <ModalFooter p="3">
              <ButtonGroup>
                <Button
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCloseAddModal();
                  }}
                  disabled={isSubmitting}
                  colorScheme="primary"
                  variant="secondary"
                  float="right"
                >
                  {t("cancel", { ns: "common" })}
                </Button>
                <Button
                  colorScheme="primary"
                  variant="solid"
                  type="submit"
                  disabled={values.projectName === "" || !isValid}
                  float="right"
                  onClick={handleCloseAddModal}
                  isLoading={isSubmitting}
                >
                  {t("edit_project_name_modal.modal_update_btn")}
                </Button>
              </ButtonGroup>
            </ModalFooter>
          </ModalContent>
        </Form>
      )}
    </Formik>
  );
};
const validationSchemaTemplateName = yup.object({
  templateName: yup.string().required("Template Name cannot be empty."),
});

export const SaveAsTemplate = ({
  props,
  handleCloseAddModal,
  onSubmit,
  previewUrl = null,
  isExportingPreview = false,
  errorMessage = null,
}) => {
  const storyType = props.props.story.payload.story_type;
  const { t } = useTranslation(["studio", "common"]);
  return (
    <Formik
      enableReinitialize
      validationSchema={validationSchemaTemplateName}
      initialValues={{
        templateName: props.props.story.payload.title,
      }}
      onSubmit={(values, { setSubmitting }) => {
        showToast({
          description: t("save_as_template_modal.toaster_message"),
          title: "Info",
          status: "info",
        });

        onSubmit(
          props,
          props.props.story.payload.id,
          props.props.pagestore.pageIds[0],
          true,
          values.templateName
        );
        setSubmitting(false);
      }}
    >
      {({ isSubmitting, isValid, values, handleChange, handleBlur }) => (
        <Form>
          <ModalContent>
            <ModalHeader p="4">
              {t("save_as_template_modal.modal_title")}
            </ModalHeader>
            <ModalCloseButton />
            <Divider my="0" />
            <ModalBody p="4">
              <StyledSaveAsTemplateTextBlock>
                {t("save_as_template_modal.modal_body")}
              </StyledSaveAsTemplateTextBlock>
              <InputGroup>
                <Input
                  type="text"
                  name="templateName"
                  placeholder={t("template_name")}
                  value={values.templateName}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
              </InputGroup>
              {storyType === StoryTypes.ANIMATED && (
                <HStack
                  mt="2"
                  alignItems="center"
                  justify="center"
                  style={{ height: "200px" }}
                >
                  {isExportingPreview && (
                    <>
                      <Spinner size="sm" mt={1} />
                      <Text ml="2">
                        {t("save_as_template_modal.modal_loading")}
                      </Text>
                    </>
                  )}
                  {previewUrl && (
                    <ReactPlayer
                      url={previewUrl}
                      controls={true}
                      width="100%"
                      height="100%"
                    />
                  )}
                </HStack>
              )}

              <ErrorMessage
                name="templateName"
                component="div"
                className="error"
              />
              {errorMessage && <Text className="error">{errorMessage}</Text>}
            </ModalBody>
            <Divider my="0" />
            <ModalFooter p="3">
              <ButtonGroup>
                <Button
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCloseAddModal();
                  }}
                  colorScheme="primary"
                  variant="secondary"
                  float="right"
                  mr={2}
                  disabled={isSubmitting}
                >
                  {t("cancel", { ns: "common" })}
                </Button>
                <Button
                  colorScheme="primary"
                  variant="solid"
                  type="submit"
                  disabled={
                    values.templateName === "" ||
                    !isValid ||
                    isExportingPreview ||
                    !!errorMessage
                  }
                  float="right"
                  isLoading={isSubmitting && isExportingPreview}
                >
                  {t("save_as_template_modal.modal_save_btn")}
                </Button>
              </ButtonGroup>
            </ModalFooter>
          </ModalContent>
        </Form>
      )}
    </Formik>
  );
};

export const TldrBadge = ({ children, badgeText = "New", hide }) => {
  return (
    <Box position="relative">
      {!(hide === true) && (
        <Badge
          position="absolute"
          left={-2}
          zIndex={1}
          top={-2.5}
          variant="solid"
        >
          {badgeText}
        </Badge>
      )}
      {children}
    </Box>
  );
};

export const EditDocumentName = ({
  documentData,
  handleCloseModal,
  onSubmit,
}) => {
  const { t } = useTranslation(["studio", "common"]);
  return (
    <Formik
      initialValues={{
        documentName: documentData.title,
      }}
      onSubmit={(values, { setSubmitting }) => {
        onSubmit(values.documentName);
        setSubmitting(false);
      }}
    >
      {({ isSubmitting, isValid, values, handleChange, handleBlur }) => (
        <Form>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader p="4">
              {t("edit_document_name_modal.modal_title")}
            </ModalHeader>
            <ModalCloseButton />
            <Divider my="0" />
            <ModalBody p="4">
              <InputGroup>
                <Input
                  type="text"
                  name="documentName"
                  placeholder="Document Name"
                  value={values.documentName}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
              </InputGroup>
              <ErrorMessage
                name="documentName"
                component="div"
                className="error"
              />
            </ModalBody>
            <Divider my="0" />
            <ModalFooter p="3">
              <ButtonGroup>
                <Button
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCloseModal();
                  }}
                  colorScheme="primary"
                  variant="secondary"
                  disabled={isSubmitting}
                  float="right"
                >
                  {t("cancel", { ns: "common" })}
                </Button>
                <Button
                  colorScheme="primary"
                  variant="solid"
                  type="submit"
                  disabled={values.documentName === "" || !isValid}
                  float="right"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCloseModal();
                  }}
                  isLoading={isSubmitting}
                >
                  {t("edit_document_name_modal.modal_update_btn")}
                </Button>
              </ButtonGroup>
            </ModalFooter>
          </ModalContent>
        </Form>
      )}
    </Formik>
  );
};
export const GetStartedBox = (props) => {
  const { t } = useTranslation(["common"]);
  const {
    title,
    description,
    onClick,
    icon,
    isNew,
    isCommingSoon,
    badgeText,
  } = props;
  return (
    <StyledDashboardGetStartedBox
      onClick={(event) => onClick(event)}
      isCommingSoon={isCommingSoon}
    >
      <div style={{ borderRadius: "8px" }}>
        {isNew && (
          <Badge
            position="absolute"
            top={0}
            right={0}
            m="0.5rem"
            variant="solid"
          >
            {badgeText ?? t("new")}
          </Badge>
        )}

        <StyledGetStartedDetailWrapper>
          {icon && icon}
          <StyledSectionTitle style={{ fontSize: "1rem", textAlign: "center" }}>
            {title}
          </StyledSectionTitle>
          <StyledMarkerplaceHelpText
            className="marketplace-template-subheader"
            style={{ fontSize: "0.75rem", textAlign: "center" }}
          >
            {description}
          </StyledMarkerplaceHelpText>
        </StyledGetStartedDetailWrapper>

        <Box visibility="hidden" textAlign="center" className="action">
          <Flex
            className="view-all"
            fontSize="0.75rem"
            justify="center"
            align="center"
          >
            {isCommingSoon ? (
              <Text className="view-all">{t("coming_soon")}</Text>
            ) : (
              <>
                <Text className="view-all" mr={2}>
                  {t("get_started")}
                </Text>
                <FaArrowRight />
              </>
            )}
          </Flex>
        </Box>
      </div>
    </StyledDashboardGetStartedBox>
  );
};

export const ConnectedPartnerProfilePicture = ({
  app_id,
  source,
  alt,
  onClick,
  className,
  tooltip,
}) => {
  function handleOnClick() {
    if (onClick) {
      onClick();
    }
  }

  return (
    <Tooltip
      hasArrow
      placement="bottom"
      label={tooltip ? tooltip : <div></div>}
    >
      <div className={`logo ${className}`} onClick={handleOnClick}>
        <div className="brand">{renderChannelIcon(app_id)}</div>
        <div className="profile-picture">
          <img
            src={
              source
                ? source
                : "https://eitrawmaterials.eu/wp-content/uploads/2016/09/person-icon.png"
            }
            alt={alt}
          />
        </div>
      </div>
    </Tooltip>
  );
};

export const TldrUserInfoView = (props) => {
  const { user } = props;
  return (
    <StyledCreatorInfo>
      <Tooltip hasArrow placement="bottom" label={user?.name || user?.email}>
        <div className="picture medium-size">
          {user?.profile_picture ? (
            <img src={user.profile_picture} alt="profile" />
          ) : (
            <FaUserCircle color="gray.500" />
          )}
        </div>
      </Tooltip>
    </StyledCreatorInfo>
  );
};

export const MediaOnlySidebarPanel = ({ children, onClose, top }) => {
  return (
    <>
      <section
        className={
          "tldr-media-only-sidebar-item-detail-slider tldr-media-only-sidebar-item-detail-slider-" +
          "open"
        }
        style={{
          top: top,
        }}
      >
        <div className="panel-container">
          <TldrSidebarCloseAnchor onClose={onClose} />
          {children}
        </div>
      </section>
    </>
  );
};

export const ToggleMenuButton = React.forwardRef(
  ({ children, onClick }, ref) => (
    <button
      className="action-btn"
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onClick(e);
      }}
    >
      <FaEllipsisV size="1em" color={light} />
    </button>
  )
);

export const TldrBeatLoader = ({ bgColor }) => {
  const bounceStyles = {
    backgroundColor: bgColor,
  };

  return (
    <span className="loading">
      <div className="spinner">
        <div className="bounce1" style={bounceStyles} />
        <div className="bounce2" style={bounceStyles} />
        <div className="bounce3" style={bounceStyles} />
      </div>
    </span>
  );
};

export const NavbarIconButton = React.forwardRef(
  ({ tooltip, ...props }, ref) => (
    <Tooltip label={tooltip} hasArrow placement="bottom">
      <IconButton {...props} ref={ref} variant="ghost" />
    </Tooltip>
  )
);

export const StoryCardCoverImage = ({
  imageSrc,
  width,
  height,
  altTitle,
  NativeImgProps,
}) => {
  return (
    <>
      {imageSrc && (
        <TLDRImage
          src={imageSrc}
          width={width ? width : "100%"}
          height={height ? height : "100%"}
          alt={altTitle}
          NativeImgProps={NativeImgProps ? NativeImgProps : {}}
        />
      )}
    </>
  );
};

export const AutoResizeTextarea = React.forwardRef((props, ref) => {
  return (
    <Textarea
      minH="unset"
      overflow="hidden"
      w="100%"
      resize="none"
      ref={ref}
      minRows={1}
      as={ResizeTextarea}
      {...props}
    />
  );
});

export const TemplateSearchImageItem = ({
  image,
  format_display_name,
  story_type,
  video,
}) => {
  const hasPreviewVideo = story_type === StoryTypes.ANIMATED && video;
  const [isHovering, setIsHovering] = useState(false);
  const [videoLoading, setVideoLoading] = useState(false);

  function onMouseLeave() {
    setIsHovering(false);
    setVideoLoading(false);
  }

  function onMouseEnter() {
    setIsHovering(true);
    setVideoLoading(true);
  }

  return (
    <>
      {story_type === StoryTypes.ANIMATED && (
        <div className="label-container">
          <FaPlay size={14} />
        </div>
      )}

      <div
        className="thumbnail"
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        {hasPreviewVideo ? (
          <>
            <TLDRImage
              NativeImgProps={{
                style: { height: "100%", width: "100%", objectFit: "cover" },
              }}
              height={"100%"}
              width={"100%"}
              src={image}
              alt={format_display_name}
            />

            {isHovering ? (
              <Tooltip label="Use template" hasArrow variant="error">
                <Box className="preview-video">
                  {videoLoading && (
                    <Spinner
                      position="absolute"
                      top="40%"
                      bottom="60%"
                      left="40%"
                      right="60%"
                      className="spin"
                    />
                  )}

                  <ReactPlayer
                    url={video}
                    muted
                    playing
                    className="video-preview"
                    width="100%"
                    height="100%"
                    controls={false}
                  />
                </Box>
              </Tooltip>
            ) : null}
          </>
        ) : (
          <TLDRImage
            NativeImgProps={{ style: { height: "100%", width: "100%" } }}
            src={image}
            height={"100%"}
            width={"100%"}
            alt={format_display_name}
          />
        )}
      </div>

      {!hasPreviewVideo ? (
        <div className="overlay-info-container">
          <FaPlusCircle size="1.5em" fill="#ffffff" />
          <Text
            isTruncated
            fontSize="14px"
            color="brand.white"
            _hover={{ color: "brand.white" }}
          >
            Use template
          </Text>
        </div>
      ) : null}
    </>
  );
};
